import { Button, Text, UnstyledButton } from '@/shared/ui';

interface Props {
  headline: string;
  caption: string;
  ctaLabel: string;
  onCta: () => void;
  compareLabel: string;
  onCompare: () => void;
}

/**
 * The calm-account offer: no alarm, just what the next plan would buy.
 *
 * @param props - Component props.
 * @returns The invite body, for use inside an OfferBlock.
 */
export function UpgradeInvite({
  headline, caption, ctaLabel, onCta, compareLabel, onCompare,
}: Props) {
  return (
    <div className="flex items-center gap-(--space-5) flex-wrap">
      <div className="flex flex-col gap-(--space-1) min-w-0" style={{ flex: '1 1 22rem' }}>
        <Text component="span" style={{
          fontSize: 'var(--text-body)', fontWeight: 'var(--font-bold)',
          color: 'var(--text-primary)', lineHeight: 'var(--leading-snug)',
        }}>
          {headline}
        </Text>
        <Text component="span" style={{
          fontSize: 'var(--text-body-sm)', color: 'var(--text-secondary)',
          lineHeight: 'var(--leading-normal)',
        }}>
          {caption}
        </Text>
      </div>
      <div className="flex items-center gap-(--space-3)" style={{ flex: 'none' }}>
        <Button size="sm" variant="solid" onClick={onCta} data-testid="invite-cta">
          {ctaLabel}
        </Button>
        <UnstyledButton onClick={onCompare} data-testid="invite-compare" style={{
          fontSize: 'var(--text-meta)', fontWeight: 'var(--font-semibold)',
          color: 'var(--seed-base)', textDecoration: 'underline',
          textUnderlineOffset: '3px', whiteSpace: 'nowrap',
        }}>
          {compareLabel}
        </UnstyledButton>
      </div>
    </div>
  );
}
